import React from 'react';
import { Input } from '@flixbus/honeycomb-react';
import { useVoucherFormContext } from '../../Context';
import { Asterisk } from '../../Asterisk';

const QuantityDiscount = () => {
  const {
    formState: {
      activeDiscount,
      payload: { discountType },
    },
    handlePayloadChange,
  } = useVoucherFormContext();

  const recognizedTypes = ['free_seat', 'free_bike', 'free_luggage', 'free_ride_marketing'];

  const discountTypeString = recognizedTypes.includes(activeDiscount)
    ? activeDiscount
    : 'free_seat';

  const currentQuantityType =
    discountType?.type === discountTypeString
      ? discountType
      : { type: discountTypeString, quantity: 1 };

  const handleQuantityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isFreeRide = ['free_ride_marketing', 'free_ride_hybrid'].includes(activeDiscount);
    const max = isFreeRide ? 2 : 1;
    const parsedValue = Math.min(Math.max(parseInt(e.target.value, 10) || 1, 1), max);

    handlePayloadChange({
      value: {
        ...currentQuantityType,
        quantity: parsedValue,
      },
      prop: 'discountType',
    });
  };

  return (
    <div>
      <Input
        name='discount-quantity'
        id='discount-quantity'
        label={
          <>
            Quantity{' '}
            {['free_ride_marketing', 'free_ride_hybrid'].includes(activeDiscount) && <Asterisk />}
          </>
        }
        {...(['free_ride_marketing', 'free_ride_hybrid'].includes(activeDiscount) && {
          info: <>Number of free rides per voucher</>,
        })}
        type='number'
        min='1'
        {...(['free_ride_marketing', 'free_ride_hybrid'].includes(activeDiscount)
          ? { max: '2' }
          : { max: '1', disabled: true })}
        required
        value={currentQuantityType.quantity}
        onChange={handleQuantityChange}
      />
    </div>
  );
};

export default QuantityDiscount;
